import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { connect } from 'react-redux';

import { StyledLoading } from 'modules/Common/form/styled';

import { JourneyEditFormWrapper, JourneyEditForm } from 'modules/journey/EditForm';

import { submitForm } from 'redux/modules/journey-edit/effects';

import { cancellationValues } from 'modules/shipper-order/Form/constants';

import { Modal } from '@ontruck/orc';
import { injectIntl } from 'react-intl';

const journeyFields = [
  'id',
  'url',
  'extra_costs',
  'currency',
  'stops',
  'net_full_cost',
  'distance_at_creation',
  'distance_type',
  'created_at',
  'pricing_version',
  'extra_version',
  'add_log',
  'route',
];

class JourneyEditModal extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(modifiedJourney, { onSave }) {
    const { submitForm, journey = {} } = this.props;

    const journeyEmbeded = journeyFields.reduce(
      (acc, field) => ({
        ...acc,
        [field]: (journey || {})[field],
      }),
      {}
    );

    submitForm(modifiedJourney, {
      initialJourney: journeyEmbeded,
      onSave,
    });
  }

  render() {
    const { onClose, journey, onSave, readOnly, intl } = this.props;
    const t = intl.messages.modules.journey.editModal;

    const journeyEmbeded = journeyFields.reduce(
      (acc, field) => ({
        ...acc,
        [field]: (journey || {})[field],
      }),
      {}
    );

    return (
      <Modal
        onClose={onClose}
        show={true}
        size="XL"
        headerComponent={readOnly ? t.viewTitle : t.title}
      >
        {journeyEmbeded && journeyEmbeded.id && (
          <JourneyEditFormWrapper
            onSubmit={this.handleSubmit}
            onSave={onSave}
            initialJourney={journeyEmbeded}
          >
            {(formikProps) => (
              <JourneyEditForm
                onClose={onClose}
                cancellationValues={cancellationValues.DEFAULT}
                {...formikProps}
                readOnly={readOnly}
              />
            )}
          </JourneyEditFormWrapper>
        )}
        {!(journeyEmbeded || {}).id && <StyledLoading />}
      </Modal>
    );
  }
}

JourneyEditModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  journey: PropTypes.object,
  onSave: PropTypes.func,
  readOnly: PropTypes.bool,
};

JourneyEditModal.defaultProps = {
  journey: {},
  readOnly: false,
};

const actionCreators = {
  submitForm,
};

export default injectIntl(connect((state) => ({}), actionCreators)(JourneyEditModal));
